import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CoconutOilPage from './Pages/CoconutOilPage';
import Policies from './Pages/Policies';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CoconutOilPage/>} />
        <Route path="/policies" element={<Policies/>} />
      </Routes>
    </Router>
  );
}